export default {
  List: {},

  Detail: {
    PlanName: 'Kế hoạch thu chi các hoạt động tài chính khác năm {0}',
    Grid: {
      LastYear: 'Ước thực hiện năm {0}',
      CurrentYear: 'Kế hoạch năm {0}',
    },
    MessageBox: {
      Message: 'Cần phải nhập liệu cho ít nhất 1 chỉ tiêu trước khi Cất.',
    },
  },
};
